import { Store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";

import Itinerary from "./Itinerary";

const Menu = ({
  allDetails,
  setArrival,
  setDeparture,
  departure,
  arrival,
  distances,
  durations,
  handleDelete,
  travelMode,
  setTravelMode,
}) => {
  const departureName =
    departure.length > 0 &&
    allDetails.find((elt) => elt.id === departure).details.name;

  const notifDelete = () => {
    Store.addNotification({
      title: "Deleted!",
      message: "Location succesfully deleted!",
      type: "danger",
      insert: "bottom-right",
      container: "bottom-right",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 1000,
        onScreen: true,
      },
    });
  };

  return (
    <section className="bg-gray-700 w-2/5 h-[100%] p-3 rounded-lg flex flex-col align-center justify-start relative mobile-second-block">
      <div className="bg-gray-800 flex justify-center items-center rounded-lg mx-auto w-2/3 h-[5vh] text-white mb-3 mt-2 gap-x-2 font-bold mobile-departure">
        Departure:
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          fill="green"
          className="w-6 h-6 "
        >
          <path
            fillRule="evenodd"
            d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
            clipRule="evenodd"
          />
        </svg>
        {departure?.length > 0 ? departureName : "Not selected"}
      </div>
      <Itinerary
        departure={departure}
        arrival={arrival}
        travelMode={travelMode}
        setTravelMode={setTravelMode}
      />
      <div className="overflow-auto h-[75%] text-white">
        {allDetails.map((elt) => {
          const dist = distances[elt.id];
          const dur = durations[elt.id];
          const isDeparture = departure === elt.id ? true : false;
          const isArrival = arrival === elt.id ? true : false;
          return (
            <button
              key={elt.id}
              className={`flex flex-col container m-3 mx-auto w-10/12 mb-2 items-center text-start justify-center bg-gray-800 rounded-lg shadow border border-gray-800 hover:border ${
                !isArrival && !isDeparture && "hover:border-orange-600"
              } ${
                isArrival && !isDeparture && "bg-orange-500 border-orange-600"
              }`}
              onClick={() => {
                !isDeparture && setArrival(elt.id);
              }}
            >
              <ul className="flex flex-col divide-y w-full">
                <li className="flex flex-row">
                  <div className="select-none cursor-pointer flex flex-1 items-center p-4">
                    <div className="flex flex-col w-10 h-10 justify-center items-center mr-4">
                      <img
                        alt={elt.details.name}
                        src={
                          elt.details.photos !== undefined
                            ? elt.details.photos[0].getUrl()
                            : "https://upload.wikimedia.org/wikipedia/commons/9/9e/Pin-location.png"
                        }
                        className="mx-auto object-cover rounded-full h-10 w-10"
                      />
                    </div>
                    <div className="flex-1 pl-1">
                      <div className="font-medium dark:text-white">
                        {elt.details.name}
                      </div>
                      <div className="text-gray-600 dark:text-gray-200 text-sm">
                        {elt.details.formatted_adress}
                      </div>
                    </div>
                    <div className="flex flex-row justify-center">
                      <div className="m-auto text-gray-200 text-xs mr-3">
                        {!isDeparture && dur}
                      </div>
                      <div className="m-auto text-gray-200 text-xs">
                        {!isDeparture && dist}
                      </div>

                      <button
                        className={`w-10 text-right flex justify-end`}
                        disabled={isDeparture}
                        onClick={(e) => {
                          e.stopPropagation();
                          setDeparture(elt.id);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill={isDeparture ? "gray" : "green"}
                          className="w-6 h-6"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                      <button
                        className="w-10 text-right flex justify-end"
                        onClick={() => {
                          handleDelete(elt.id);
                          notifDelete();
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="red"
                          className="w-6 h-6"
                        >
                          <path
                            fillRule="evenodd"
                            d="M16.5 4.478v.227a48.816 48.816 0 013.878.512.75.75 0 11-.256 1.478l-.209-.035-1.005 13.07a3 3 0 01-2.991 2.77H8.084a3 3 0 01-2.991-2.77L4.087 6.66l-.209.035a.75.75 0 01-.256-1.478A48.567 48.567 0 017.5 4.705v-.227c0-1.564 1.213-2.9 2.816-2.951a52.662 52.662 0 013.369 0c1.603.051 2.815 1.387 2.815 2.951zm-6.136-1.452a51.196 51.196 0 013.273 0C14.39 3.05 15 3.684 15 4.478v.113a49.488 49.488 0 00-6 0v-.113c0-.794.609-1.428 1.364-1.452zm-.355 5.945a.75.75 0 10-1.5.058l.347 9a.75.75 0 101.499-.058l-.346-9zm5.48.058a.75.75 0 10-1.498-.058l-.347 9a.75.75 0 001.5.058l.345-9z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </li>
              </ul>
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default Menu;
